module.exports = __webpack_public_path__ + "static/android-chrome-512x512-0f9f5698ae85cf4ee16693774fe6d300.png";